import React from "react";

import { formatDocument } from "../../../utils/formatDoc";
import { TIPO_TONE } from "./filtros";

// Células compartilhadas pela lista e pelo detalhe da Pesquisa CT-e (PO1-2968).

export function TipoBadge({ item }) {
  if (!item || item.tipoLabel == null) return <span>-</span>;
  const tone = TIPO_TONE[Number(item.tipoConhecimento)] || "neutral";
  return <span className={`pesquisa-doc-tipo pesquisa-doc-tipo--${tone}`}>{item.tipoLabel}</span>;
}

export function TomadorCell({ item }) {
  if (!item || (!item.tomador && !item.tomadorCnpj)) return <span>-</span>;
  return (
    <div className="pesquisa-doc-tomador">
      <strong>{item.tomador || formatDocument(item.tomadorCnpj)}</strong>
      <small>{formatDocument(item.tomadorCnpj)}</small>
      {item.papelTomadorLabel ? <span className="pesquisa-doc-papel">{item.papelTomadorLabel}</span> : null}
    </div>
  );
}
